<template>
  <div class="flex items-center p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
    <div class="flex-shrink-0 mr-4">
      <!-- Google Icon -->
      <svg v-if="icon === 'google'" class="w-6 h-6 text-gray-700 dark:text-gray-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 19">
        <path fill-rule="evenodd" d="M8.842 18.083a8.8 8.8 0 0 1-8.65-8.948 8.841 8.841 0 0 1 8.8-8.652h.153a8.464 8.464 0 0 1 5.7 2.257l-2.193 2.038A5.27 5.27 0 0 0 9.09 3.4a5.882 5.882 0 0 0-.2 11.76h.124a5.091 5.091 0 0 0 5.248-4.057L14.3 11H9V8h8.34c.066.543.095 1.09.088 1.636-.086 5.053-3.463 8.449-8.4 8.449l-.186-.002Z" clip-rule="evenodd" />
      </svg>

      <!-- Chart Icon -->
      <svg v-else-if="icon === 'chart'" class="w-6 h-6 text-gray-700 dark:text-gray-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 16">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1v14h16m0-9-3-2-3 5-3-2-3 4" />
      </svg>
    </div>

    <div class="flex-1">
      <h4 class="text-sm font-medium text-gray-900 dark:text-white">
        {{ title }}
      </h4>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        <span v-if="connectedCount === 0">Not connected</span>
        <span v-else-if="connectedCount === 1">1 connected</span>
        <span v-else>{{ connectedCount }} connected</span>
      </p>
    </div>

    <div class="flex items-center space-x-2">
      <!-- Connect/Coming Soon Button -->
      <button
        v-if="disabled"
        disabled
        class="px-4 py-2 text-sm font-medium text-gray-400 bg-gray-100 rounded-lg cursor-not-allowed dark:bg-gray-600 dark:text-gray-500">
        {{ disabledText }}
      </button>

      <a
        v-else
        :href="connectUrl"
        class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-primary-300 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:text-white">
        Connect
      </a>

      <!-- View Button -->
      <button
        v-if="connectedCount > 0 && !disabled"
        @click="$emit('view')"
        class="p-2 text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-primary-300 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700">
        <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 14">
          <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path d="M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
            <path d="M10 13c4.97 0 9-2.686 9-6s-4.03-6-9-6-9 2.686-9 6 4.03 6 9 6Z" />
          </g>
        </svg>
        <span class="sr-only">View connected accounts</span>
      </button>
    </div>
  </div>
</template>

<script setup>
// Props
defineProps({
  icon: {
    type: String,
    required: true,
    validator: (value) => ['google', 'chart'].includes(value)
  },
  title: {
    type: String,
    required: true
  },
  connectedCount: {
    type: Number,
    default: 0
  },
  connectUrl: {
    type: String,
    default: '#'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  disabledText: {
    type: String,
    default: 'Coming Soon'
  }
})

// Emits
defineEmits(['view'])
</script>
